import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { getCommunityLogo } from '../theme';

async function importCommunityLogo(logoFileName: string): Promise<string> {
  try {
    const logoModule = await import(`../assets/communityLogos/${logoFileName}`);
    return logoModule.default;
  } catch (error) {
    console.warn(`Failed to import community logo: ${logoFileName}`, error);
    return '/favicon.ico';
  }
}

function updateDocumentTitle(title: string) {
  document.title = title;
}

function updateFavicon(iconUrl: string) {
  const existingFavicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  if (existingFavicon) {
    existingFavicon.remove();
  }

  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/svg+xml';
  link.href = iconUrl;
  document.head.appendChild(link);
}

function parseRouteInfo(pathname: string) {
  console.log('Parsing route info from pathname:', pathname);
  const pathParts = pathname.split('/').filter(Boolean);
  

  const routeParts = pathParts.slice(0); 
  console.log('Route parts:', routeParts);
  
  let appType = '';
  let community = '';
  
  if (routeParts.length >= 1) {
    appType = routeParts[0];
  }
  
  if (routeParts.length >= 3 && appType === 'chatbot') {
    community = routeParts[2];
  }
  
  return { appType, community };
}

export function useDynamicPageMeta() {
  const location = useLocation();

  useEffect(() => {
    const updatePageMeta = async () => {
      const { appType, community } = parseRouteInfo(location.pathname);
      console.log(`App Type: ${appType}, Community: ${community}`);
      
      // 设置标题
      let title = 'EasySupport';
      if (appType === 'chatbot') {
        title = 'Fiona';
      } else if (appType === 'translator') {
        title = 'EasySupport - Translator';
      }
      
      updateDocumentTitle(title);
      
      if (appType === 'chatbot' && community) {
        const communityLogoFileName = getCommunityLogo(community);
        if (communityLogoFileName) {
          try {
            const logoPath = await importCommunityLogo(communityLogoFileName);
            updateFavicon(logoPath);
          } catch (error) {
            console.warn(`Failed to load community logo for ${community}`, error);
            updateFavicon('/favicon.ico');
          }
        } else {
          updateFavicon('/favicon.ico');
        }
      } else {
        updateFavicon('/favicon.ico');
      }
      
      console.log(`Updated page meta - Title: ${title}, App: ${appType}, Community: ${community}`);
    };
    
    updatePageMeta();
    
  }, [location.pathname]);
}
